var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.021,
    height: 18.974,
    viewBox: "0 0 30.021 18.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shipping",
    transform: "translate(0.021 -94.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(0 94.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M27.9,102.107,27.123,99a.47.47,0,0,0,.372-.459v-.5a1.975,1.975,0,0,0-1.973-1.973H21.983V95.033a.972.972,0,0,0-.971-.971H2.975A.972.972,0,0,0,2,95.033v8.518a.47.47,0,1,0,.939,0V95.033A.031.031,0,0,1,2.975,95H21.013a.031.031,0,0,1,.031.031v8.518a.47.47,0,0,0,.939,0v-.533h5.544a1.537,1.537,0,0,1,1.46,1.065H27.526a.47.47,0,0,0-.47.47v1a1.473,1.473,0,0,0,1.472,1.472h.532v2.067H27.832a2.974,2.974,0,0,0-5.623,0h-.226v-3.539a.47.47,0,1,0-.939,0v3.539H11.3a2.974,2.974,0,0,0-5.623,0h-2.7a.031.031,0,0,1-.031-.031v-1.033H4.979a.47.47,0,1,0,0-.939H.47a.47.47,0,1,0,0,.939H2v1.033a.972.972,0,0,0,.971.971H5.512v.031a2.975,2.975,0,0,0,5.95,0v-.031H22.047v.031a2.975,2.975,0,0,0,5.95,0v-.031H29.53a.47.47,0,0,0,.47-.47v-5.01a2.478,2.478,0,0,0-2.1-2.443Zm-5.917-5.1h3.539a1.035,1.035,0,0,1,1.033,1.033v.031H21.983Zm0,5.073V99.01h4.174l.767,3.069ZM8.486,112.1a2.035,2.035,0,1,1,2.035-2.035A2.035,2.035,0,0,1,8.486,112.1Zm16.534,0a2.035,2.035,0,1,1,2.035-2.035A2.035,2.035,0,0,1,25.02,112.1Zm4.04-6.013h-.532a.533.533,0,0,1-.532-.532v-.532h1.065v1.065Z",
    transform: "translate(0 -94.062)",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(7.446 108.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M129.367,350.6a1.1,1.1,0,1,0,1.1,1.1,1.1,1.1,0,0,0-1.1-1.1Z",
    transform: "translate(-128.267 -350.597)",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(23.257 108.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8547",
    "data-name": "Path 8547",
    d: "M411.555,350.6a1.1,1.1,0,1,0,1.1,1.1A1.1,1.1,0,0,0,411.555,350.6Z",
    transform: "translate(-410.455 -350.597)",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    transform: "translate(11.447 106.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8548",
    "data-name": "Path 8548",
    d: "M213.709,316.393h-7.95a.533.533,0,1,0,0,1.065h7.95a.533.533,0,1,0,0-1.065Z",
    transform: "translate(-205.227 -316.393)",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    transform: "translate(1.136 105.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8549",
    "data-name": "Path 8549",
    d: "M24.448,282.188H17.634a.533.533,0,1,0,0,1.065h6.814a.533.533,0,0,0,0-1.065Z",
    transform: "translate(-17.102 -282.188)",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090",
    transform: "translate(8.108 98.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8550",
    "data-name": "Path 8550",
    d: "M154.228,171.178a.532.532,0,0,0-.753,0l-4.734,4.734-2.463-2.463a.532.532,0,1,0-.753.753l2.839,2.839a.532.532,0,0,0,.753,0l5.11-5.11a.532.532,0,0,0,0-.753Z",
    transform: "translate(-145.37 -171.023)",
    fill: "#818181"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.fdfdf561cf6cb03e1850e06fa0778e35.svg";
export { ForwardRef as ReactComponent };